export default __webpack_public_path__ + "static/media/younger.caa6f6b0.png";